module.exports = __webpack_public_path__ + "img/CompScope_Mag_3_Focus_1.0cd97797.png";